export const recruiterJobStatusOptions = [
  { value: "", label: "All Statuses" },
  { value: "active", label: "Active" },
  { value: "draft", label: "Draft" },
  { value: "closed", label: "Closed" },
];

export const applicationStatusOptions = [
  { value: "", label: "All Applicants" },
  { value: 0, label: "Applied" },
  { value: 1, label: "Under Review" },
  { value: 2, label: "Shortlisted" },
  { value: 3, label: "Interview Scheduled" },
  { value: 4, label: "Selected" },
  { value: 5, label: "Rejected" },
  { value: 6, label: "Withdrawn" },
];

export const employmentTypeOptions = [
  { value: "full_time", label: "Full Time" },
  { value: "part_time", label: "Part Time" },
  { value: "contract", label: "Contract" },
  { value: "internship", label: "Internship" },
  { value: "temporary", label: "Temporary" },
  { value: "freelance", label: "Freelance" },
];

export const workModeOptions = [
  { value: "onsite", label: "Onsite" },
  { value: "remote", label: "Remote" },
  { value: "hybrid", label: "Hybrid" },
];

export const jobStatusUpdateOptions = [
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "closed", label: "Closed" },
];

export const getApplicationStatusLabel = (status) => {
  const match = applicationStatusOptions.find(
    (option) => Number(option.value) === Number(status)
  );
  return match?.label || "Applied";
};
